import AccountInfo from "state/AccountInfo";
import Constants from "utils/Constants";

/**
 * 数据上报基抽象础类
 */
export default abstract class BaseReporter {
    abstract report(eventName: string, data?: object);

    /**
     * 用户登录后的画像设置
     */
    abstract setProfile(locale: string, accountInfo: AccountInfo);

    abstract reset(): void;

    abstract updateProfile(userId: string, profile: {}): void;

    /**
     *
     * @returns
     */
    static FormateLoginProfile(locale: string, accountInfo: AccountInfo) {
        const searchParams = new URLSearchParams(window.location.search);
        const referral = searchParams.get("referral") || window.localStorage.getItem("referral") || "";
        const source = searchParams.get("source") || window.localStorage.getItem("source") || "";
        return {
            // 语言
            locale: locale,
            // 用户ID
            user_id: accountInfo.userId,
            // 设备编号
            device_id: Constants.deviceId,
            // 系统版本
            app_version: Constants.clientId,
            // 账户注册类型，一般是邮箱或电话号码
            account_type: accountInfo.masterAccount?.account_type,
            // 注册邀请码
            referral_code: accountInfo.referralCode,
            // 用户昵称
            nickname: accountInfo.nickname,
            // 返佣等级
            rebate_level: accountInfo.rebateLevel ? accountInfo.rebateLevel?.currentLevel.level : "null",
            referral,
            source,
        };
    }

    static FormateRegisterProfile(locale: string, accountInfo: AccountInfo) {
        return {
            ...BaseReporter.FormateLoginProfile(locale, accountInfo),
            // 注册设备
            sign_up_device: "web",
            // 注册时间
            sign_up_date: accountInfo.createTime,
        };
    }
}
